import { GridColDef } from '@mui/x-data-grid';
import { fieldEquivalences } from './props';
import { QuestionHistorical } from '../../../../shared/types/survey.interface';

export const useQuestionHistorical = (historical: QuestionHistorical[]) => {
    const columns: GridColDef[] = [
        {
            field: 'questionChange',
            headerName: 'Pregunta Modificada',
            minWidth: 120,
            flex: 0.3,
            sortable: false,
            renderCell: (question) => (
                <span>
                    {question.row?.question?.description ||
                    question?.row?.answer?.question?.description
                        ? fieldEquivalences[
                            question.row?.question?.description
                        ] ||
                          fieldEquivalences[
                              question?.row?.answer?.question?.description
                          ] ||
                          question.row?.question?.description ||
                          question?.row?.answer?.question?.description
                        : ''}
                </span>
            ),
        },
        {
            field: 'fieldChange',
            headerName: 'Campo Modificado',
            minWidth: 120,
            flex: 0.3,
            sortable: false,
            renderCell: (question) => (
                <span>
                    {question.row.elementos.field
                        ? fieldEquivalences[question.row.elementos.field] ||
                          question.row.elementos.field
                        : ''}
                </span>
            ),
        },
        {
            field: 'oldValue',
            headerName: 'Valor Anterior',
            minWidth: 120,
            flex: 0.4,
            sortable: false,
            renderCell: (question) => (
                <span>{`${question.row.elementos.oldValue}`}</span>
            ),
        },
        {
            field: 'newValue',
            headerName: 'Valor Nuevo',
            minWidth: 120,
            sortable: false,
            flex: 0.4,
            renderCell: (question) => (
                <span>{`${question.row.elementos.newValue}`}</span>
            ),
        },
        {
            field: 'process',
            headerName: 'Proceso realizado',
            minWidth: 120,
            sortable: false,
            flex: 0.25,
            renderCell: (question) => (
                <span>{`${
                    question.row.elementos.field === 'status' &&
                    question.row.elementos.newValue === 'eliminado'
                        ? 'Eliminación'
                        : 'Modificación'
                }`}</span>
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de modificación',
            minWidth: 100,
            sortable: false,
            flex: 0.3,
            renderCell: (question) => (
                <span>
                    {new Date(question.row.created_at as Date).toLocaleString()}
                </span>
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 120,
            sortable: false,
            flex: 0.4,
            renderCell: (question) => (
                <span>
                    {question.row.createdBy
                        ? `${question.row.createdBy.username}`
                        : ''}
                </span>
            ),
        },
    ];

    const rows =
        historical?.flatMap((row) => {
            if (row.changes) {
                const { changes, created_at, createdBy } = row;
                return changes.map((elemento, index) => ({
                    ...row,
                    elementos: elemento,
                    id: `${row.id}-${index}`,
                    created_at,
                    createdBy,
                }));
            }
            return [];
        }) || [];

    return {
        columns,
        rows,
    };
};
